import React from 'react';
import type { FormInstance } from 'antd';
import { LineStyleWordRibbon, type TagEditRibbonConfig } from './LineStyleWordRibbon';

export type ColorWatch = {
  color?: string;
  backgroundColor?: string;
  borderColor?: string;
};

export type StyleTabItem = {
  key: string;
  label: React.ReactNode;
  children: React.ReactNode;
};

type Props = {
  form: FormInstance;
  colors: ColorWatch;
  namePrefix?: string | string[];
  mode?: 'line' | 'header';
  showSpan?: boolean;
  includeStyleSections?: boolean;
  /** @deprecated use defaultActiveTab */
  defaultActiveKey?: string[];
  defaultActiveTab?: string;
  extraItems?: StyleTabItem[];
  tagEdit?: TagEditRibbonConfig;
  disabled?: boolean;
  listContentField?: string;
  contentTextareaRef?: React.RefObject<import('antd/es/input/TextArea').TextAreaRef | null>;
  listValue?: string;
  onListChange?: (text: string) => void;
};

export const LineStyleEditTabs: React.FC<Props> = (props) => <LineStyleWordRibbon {...props} />;

/** Alias kept for existing imports */
export const LineStyleEditCollapse = LineStyleEditTabs;
